import { useEffect } from 'react';
import { useFiltersContext, FilterDataTyped } from '@nexelem/filters';
import { FormProvider, useForm } from 'react-hook-form';
import { DrawerFiltersData } from './TasksDrawerFilters';
import { FormProductionQueueSelect } from '../../../../../molecules/FormComponents/FormProductionQueueSelect';

export type FormValues = {
  queues?: number[];
};

export const ProductionQueueSelect = () => {
  const { onChange, onRegister, filters } = useFiltersContext();
  const typedFilters = filters as FilterDataTyped<DrawerFiltersData>;
  const form = useForm<FormValues>();

  useEffect(() => {
    onRegister({
      path: 'queues',
      value: undefined,
      isMultiple: true,
    });
  }, [onRegister]);

  useEffect(() => {
    form.setValue('queues', typedFilters.queues?.value);
  }, [typedFilters, form]);

  useEffect(() => {
    const { unsubscribe } = form.watch((value) => {
      onChange('queues', {
        value: value.queues,
        isMultiple: true,
      });
    });

    return () => unsubscribe();
  }, [onChange, form]);

  return (
    <FormProvider {...form}>
      <FormProductionQueueSelect name="queues" />
    </FormProvider>
  );
};
